import { DatePipe, formatDate } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GridComponent, PageSettingsModel, QueryCellInfoEventArgs, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { count } from 'console';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { EventEmitterBo, functionpermission, MultipleSessionBO, saveEvvTimesheetBO } from '../evvtimesheet.model';
import { EvvTimesheetService } from '../evvtimesheet.service';
import { EvvTimesheetEditService } from './evvtimesheet-edit.service';

@Component({
  selector: 'app-evvtimesheet-edit',
  templateUrl: './evvtimesheet-edit.component.html',
  styleUrls: ['./evvtimesheet-edit.component.scss']
})
export class EvvtimesheetEditComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  EmployeeEditFilter: any;
  checkedEvvTimesheetList: any = [];
  ClientEditFilter: any;
  serviceId: any;
  validateTotalAmount: number = 0;
  showTotalamount: any;
  createEvvTimesheetList: any = []
  EvvTimesheetOrderList: any = [];
  ServiceEditFilter: any = [];
  EmployeePayrateList: any = [];
  PayerList: any = []
  enteredhour: number = 0;
  enteredminutes: number = 0;
  FromDateFilter: any;
  AllTotalhours: string = "";
  saveTimesheetBO: saveEvvTimesheetBO = new saveEvvTimesheetBO();
  multipleSession: MultipleSessionBO[] = []
  EmployeeMappedList: any = [];
  EndDateFilter: any;
  setTimesheetList: any = [];
  RelationshipEditFilter: any;
  RemainingAmountEditFilter: any;
  RateEditFilter: any;
  public formatOptions: object;
  isAuthorizationDetails: boolean = false;
  ActiveAuthorizationList: any = [];
  PayorEditFilter: any;
  isNoAuthorizationDetails: Boolean = false;
  public AuthorizationinitialPage: PageSettingsModel;
  @Input() EditInputProperty: EventEmitterBo = new EventEmitterBo();
  @Output() EditOutputTimesheet = new EventEmitter<EventEmitterBo>();
  // saveTimesheetInfo: EVVTimesheetBO = new EVVTimesheetBO();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true
  };
  @ViewChild("gridTable") public gridTable: GridComponent;
  IsButtonDisable: boolean = false;

  constructor(private CDR: ChangeDetectorRef, public EditService: EvvTimesheetEditService,
    public dateservice: DateService,
    public datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    public TService: EvvTimesheetService,
    public TEditservice: EvvTimesheetEditService, public global: GlobalComponent,
    public toasterservice: ToastrService, public general: GeneralService, public datepipe: DatePipe) { }
  fp: functionpermission = new functionpermission()
  ngOnInit(): void {

    this.GetClientDropdown();
    this.AuthorizationinitialPage = { pageSize: 5 };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };

    let goal1 = new MultipleSessionBO();
    this.multipleSession.push(goal1)
  }



  //.......................................DateFormat.................................................
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'SaveFromDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.FromDateFilter = element;
        }
      }
      if (name == 'SaveEndDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.EndDateFilter = element;
        }
      }

    }
    if (type == "datechanged") {
      if (name == 'SaveFromDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.FromDateFilter = element;
          this.getActiveAuthorization();
          if (this.FromDateFilter != null && this.FromDateFilter != undefined && this.FromDateFilter != '' && this.EndDateFilter != null && this.EndDateFilter != undefined && this.EndDateFilter != '') {
            this.GetEmployeePayrateForClient().then(() => {
              this.assignTimesheets();
            });
          }

        }
      }
      if (name == 'SaveEndDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.EndDateFilter = element;
          this.getActiveAuthorization();
          if (this.FromDateFilter != null && this.FromDateFilter != undefined && this.FromDateFilter != '' && this.EndDateFilter != null && this.EndDateFilter != undefined && this.EndDateFilter != '' && this.ServiceEditFilter != null && this.ServiceEditFilter != undefined && this.ServiceEditFilter != '') {
            this.GetEmployeePayrateForClient().then(() => {
              this.assignTimesheets();
            });
          }
        }
      }

    }
  }
  //....................................rowSelected........................................................
  rowSelected(args: RowSelectEventArgs) {
    var rowList: any = args.data;
    this.RemainingAmountEditFilter = rowList.balanceAmount;
    this.PayorEditFilter = rowList.payor;
    this.RateEditFilter = rowList.rate;
    this.ServiceEditFilter = rowList.id;
    this.GetEmployeePayrateForClient().then(() => {
      this.assignTimesheets();
    });

  }
  //................................................customiseCell.....................................................
  customiseCell(args: QueryCellInfoEventArgs) {
    if (args.column.field === 'balanceAmount') {
      if (args.data[args.column.field] < 0) {
        args.cell.classList.add('mark');
      }
    }
  }
  //..................................................getRelationship.................................................
  getRelationship() {
    if (this.EmployeeEditFilter != null && this.EmployeeEditFilter != undefined && this.EmployeeEditFilter != '') {
      let a = this.EmployeeMappedList?.filter(a => a.employeeId == this.EmployeeEditFilter)[0];
      this.RelationshipEditFilter = a.relationship;
      this.clearEmployeeFields();
    }
    else {
      this.RelationshipEditFilter = null;
      this.EmployeeEditFilter = "";
      this.clearEmployeeFields();

    }
  }
  clearEmployeeFields() {
    this.ServiceEditFilter = "";
    this.RateEditFilter = null;
    this.FromDateFilter = "";
    this.EndDateFilter = "";
    this.PayorEditFilter = "";
    this.RemainingAmountEditFilter = null;
    this.validateTotalAmount = 0;
    this.showTotalamount = 0;
    this.AllTotalhours = "";
    this.enteredhour = 0;
    this.enteredminutes = 0;
    this.EvvTimesheetOrderList = [];
    this.createEvvTimesheetList = [];
    this.isAuthorizationDetails = false;
    this.isNoAuthorizationDetails = false;
  }
  //........................................GetMappedEmployees.......................................
  GetEmployeePayrateForClient() {
    if (this.ClientEditFilter != null && this.ClientEditFilter != undefined && this.ClientEditFilter != '' &&
      this.EmployeeEditFilter != null && this.EmployeeEditFilter != undefined && this.EmployeeEditFilter != '' &&
      this.ServiceEditFilter != null && this.ServiceEditFilter != undefined && this.ServiceEditFilter != '' &&
      this.FromDateFilter != null && this.FromDateFilter != undefined && this.FromDateFilter != '' &&
      this.EndDateFilter != null && this.EndDateFilter != undefined && this.EndDateFilter != '' &&
      this.ActiveAuthorizationList.length > 0) {
      let a = this.ActiveAuthorizationList?.filter(a => a.id == this.ServiceEditFilter)[0];
      this.serviceId = a.serviceId;
      return new Promise((resolve, reject) => {
        let params = new URLSearchParams();
        params.append("clientId", this.ClientEditFilter);
        params.append("employeeId", this.EmployeeEditFilter);
        params.append("serviceId", this.serviceId);
        params.append("start", this.global.getDateTimeString(this.FromDateFilter));
        params.append("end", this.global.getDateTimeString(this.EndDateFilter));
        this.TEditservice.GetEmployeePayrateForClient(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.EmployeePayrateList = data;

          resolve(data)
        }, (err) => {
          reject(err)
        });
      });
    }
  }
  //........................................GetMappedEmployees.......................................
  GetMappedEmployees() {
    if (this.ClientEditFilter != null && this.ClientEditFilter != undefined && this.ClientEditFilter != '') {
      this.clearFields();
      let params = new URLSearchParams();
      params.append("clientId", this.ClientEditFilter);
      this.TService.GetMappedEmployees(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.EmployeeMappedList = data;
      })
    }
    else {
      this.clearFields();
    }
  }
  ClientDropdown: any = [];
  GetClientDropdown() {
    this.EditService.GetClientDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientDropdown = data;
    })
    this.GetMappedEmployees();
  }

  clearFields() {
    this.ServiceEditFilter = "";
    this.EmployeeEditFilter = "";
    this.EmployeeMappedList = [];
    this.RateEditFilter = null;
    this.RelationshipEditFilter = "";
    this.FromDateFilter = "";
    this.EndDateFilter = "";
    this.PayorEditFilter = "";
    this.RemainingAmountEditFilter = null;
    this.validateTotalAmount = 0;
    this.showTotalamount = 0;
    this.AllTotalhours = "";
    this.enteredhour = 0;
    this.enteredminutes = 0;
    this.EvvTimesheetOrderList = [];
    this.createEvvTimesheetList = [];
    this.isAuthorizationDetails = false;
    this.isNoAuthorizationDetails = false;
  }
  //........................................getActiveAuthorization.......................................
  getActiveAuthorization() {
    if (this.ClientEditFilter != null && this.ClientEditFilter != undefined && this.ClientEditFilter != '' &&
      this.EmployeeEditFilter != null && this.EmployeeEditFilter != undefined && this.EmployeeEditFilter != '' &&
      this.FromDateFilter != null && this.FromDateFilter != undefined && this.FromDateFilter != '' &&
      this.EndDateFilter != null && this.EndDateFilter != undefined && this.EndDateFilter != '') {
      let params = new URLSearchParams();
      params.append("clientId", this.ClientEditFilter);
      params.append("fromDate", this.global.getDateTimeString(this.FromDateFilter));
      params.append("toDate", this.global.getDateTimeString(this.EndDateFilter));
      params.append("employeeId", this.EmployeeEditFilter);
      this.TEditservice.getActiveAuthsWithinDateRange(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.ActiveAuthorizationList = data;

        this.ActiveAuthorizationList.forEach(authItems => {
          authItems.id = authItems.id;
          authItems.fields = authItems.service + "," + authItems.serviceName;
        });
        if (data.length > 0) {
          this.isAuthorizationDetails = true;
          this.isNoAuthorizationDetails = false;
        }
        else {
          this.isAuthorizationDetails = false;
          this.isNoAuthorizationDetails = true;
          this.ActiveAuthorizationList = [];
          this.ServiceEditFilter = null;
        }
      })
    }
  }

  // ................................................calculatehours......................................................
  calculatehours(EvvTimesheetOrderList) {
    let totalhours = EvvTimesheetOrderList?.filter(t => t.hours != undefined && t.hours != null).map(t => t.hours).reduce((sum, sum1) => { return parseFloat(sum) + parseFloat(sum1) })
    let val5 = ((totalhours).toString()).split('.');
    if (val5.length == 2) {
      if (val5[val5.length - 1].length == 1) {
        val5[val5.length - 1] = parseInt(val5[val5.length - 1]) * 10;
      }
      if (parseFloat(0 + "." + val5[val5.length - 1]) == 0) {
        this.enteredhour = val5[0];
        this.enteredminutes = 0;
      }
      if (parseFloat(0 + "." + val5[val5.length - 1]) == 0.25) {
        this.enteredhour = val5[0];
        this.enteredminutes = 15;
      }
      if (parseFloat(0 + "." + val5[val5.length - 1]) == 0.50) {
        this.enteredhour = val5[0];
        this.enteredminutes = 30;
      }
      if (parseFloat(0 + "." + val5[val5.length - 1]) == 0.75) {
        this.enteredhour = val5[0];
        this.enteredminutes = 45;
      }
    }
    else {
      this.enteredhour = val5[0]; this.enteredminutes = 0;
    }

    this.calculateTotalAmount(EvvTimesheetOrderList);
  }
  //................................................calculateTotalAmount.......................................
  calculateTotalAmount(EvvTimesheetOrderList) {
    this.showTotalamount = 0;
    console.log(EvvTimesheetOrderList, "EvvTimesheetOrderList")
    EvvTimesheetOrderList.forEach(element => {
      if (element.Rate != 0 && element.Rate != undefined && element.Rate != null
        && element.hours != 0 && element.hours != null && element.hours != undefined
      ) {
        console.log(element, "ee")
        element.totalAmount = parseFloat((element.Rate * element.hours).toFixed(2));
        this.showTotalamount += element.totalAmount;
        console.log(this.showTotalamount, "this.showTotalamount")
      }
      else {
        element.totalAmount = null;
      }


    });
    this.showTotalamount = parseFloat(this.showTotalamount).toFixed(2)

  }
  Rate = 0;
  WithOutClient = '';
  WithClient = ''
  End = ''
  withoutclient: boolean = false;

  getPayrate(date) {

    this.EmployeePayrateList.forEach(element => {

      if ((new Date(element.fromDate)) <= (new Date(date)) &&

        (new Date(element.toDate)) >= (new Date(date))) {

        if (element.clientId != null && element.clientId != undefined && element.clientId != '') {

          this.Rate = element.rate;

        }
        else if (this.Rate != null && this.Rate != undefined && this.Rate != 0) {
          return this.Rate

        }
        else {
          this.Rate = element.rate

        }
      }

    });

  }


  //..........................................assignTimesheets........................................
  async assignTimesheets() {

    if (this.ServiceEditFilter != null && this.ServiceEditFilter != '' && this.ServiceEditFilter != undefined && this.ServiceEditFilter != "" &&
      this.FromDateFilter != null && this.FromDateFilter != undefined && this.FromDateFilter != '' &&
      this.EndDateFilter != null && this.EndDateFilter != undefined && this.EndDateFilter != ''
    ) {
      if ((new Date(this.FromDateFilter).getTime() < new Date(this.EndDateFilter).getTime()) || (this.FromDateFilter == this.EndDateFilter)) {
        {


          this.EvvTimesheetOrderList = [];

          var FromDate = new Date(this.FromDateFilter);
          var EndDate = new Date(this.EndDateFilter);
          var daysDifferent = Math.floor((Date.UTC(EndDate.getFullYear(), EndDate.getMonth(), EndDate.getDate()) -
            Date.UTC(FromDate.getFullYear(), FromDate.getMonth(), FromDate.getDate())) / (1000 * 60 * 60 * 24));
          for (let i: number = 0; i <= daysDifferent; i++) {
            var Value1 = new Date(FromDate)
            Value1.setDate(Value1.getDate() + i);
            let hours = 0;

            let booleanValidation = false;
            let timesheetid = "00000000-0000-0000-0000-000000000000";

            var Value2: any = new Date(Value1).getDay()
            switch (Value2) {
              case 0:
                Value2 = "Sunday";
                break;
              case 1:
                Value2 = "Monday";
                break;
              case 2:
                Value2 = "Tuesday";
                break;
              case 3:
                Value2 = "Wednesday";
                break;
              case 4:
                Value2 = "Thursday";
                break;
              case 5:
                Value2 = "Friday";
                break;
              case 6:
                Value2 = "Saturday";
            }

            let AuthService = this.ActiveAuthorizationList?.filter(s => s.id == this.ServiceEditFilter)[0];

            let Fields = AuthService.service + "," + AuthService.serviceName;
            this.getPayrate(Value1)

            this.createEvvTimesheetList = {
              Id: timesheetid != '' ? timesheetid : "00000000-0000-0000-0000-000000000000",
              Days: Value2,
              isHighlighted: booleanValidation,
              StartDate: (new Date(Value1).getMonth() + 1) + '/' + new Date(Value1).getDate() + '/' + new Date(Value1).getFullYear(),
              EndDate: (new Date(Value1).getMonth() + 1) + '/' + new Date(Value1).getDate() + '/' + new Date(Value1).getFullYear(),
              // Rate: (this.Rate != undefined && this.Rate != null && this.Rate != 0
              // ) ? this.Rate : this.RateEditFilter,
              Rate: this.RateEditFilter,
              Authorizationservice: Fields,
              hours: (hours != null && hours != undefined && hours != 0) ? hours : 0,
              totalAmount: 0,
              reasonForModify: this.reasonForModify,
              multiplesessionBO: []
            }
            this.Rate = 0
            this.EvvTimesheetOrderList.push(this.createEvvTimesheetList);


          }
        }
      }
      this.calculateTotalAmount(this.EvvTimesheetOrderList);
      if (this.checkedEvvTimesheetList.length > 0) {
        this.calculatehours(this.EvvTimesheetOrderList);
      }
    }
    else {
      this.enteredhour = 0;
      this.enteredminutes = 0;

    }

  }
  //......................................................GetcheckedTimesheets...................................................

  // .................................................numberonly........................................................................
  numberonly(event: any, TimesheetType) {
    this.CDR.detach();
    setInterval(() => {
      this.CDR.detectChanges();
    }, 10);
    if (((event.which < 48 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 57) && ((event.which < 96 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 105)) {
      event.preventDefault();
    }
    let text = "";
    if (TimesheetType == "create") {
      text = event.target.innerHTML;
    }
    if (TimesheetType == "All") {
      text = this.AllTotalhours;
    }
    text = (text.trim) ? text.trim() : text.replace(/^\s+/, '');
    if (text.length == 1) {
      if (text == "2") {
        if (event.key > 3) {
          event.preventDefault();
        }
      }
      if (parseInt(text) > 2) {
        if (event.which != 46) {
          event.preventDefault();
        }
      }
      if (text == '.') {
        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }

    }
    if (text.length == 2) {
      let array = text.split("");
      if (!(array[1] == ".")) {
        if (array[0] == ".") {
          if (array[1] == "5" || array[1] == "0") {
            if (!(event.which == 48)) {
              event.preventDefault();
            }
          }
          if (array[1] == "2" || array[1] == "7") {
            if (!(event.which == 53)) {
              event.preventDefault();
            }
          }
        }
        else if (event.which != 46) {
          event.preventDefault();
        }

      }
      else {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }
    }
    if (text.length == 3) {
      let array = text.split("");
      if (array[0] == ".") {
        event.preventDefault();
      }
      if (array[2] == ".") {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }
      if (array[1] == ".") {
        let List = text.split(".");
        if (List[1] == "5" || List[1] == "0") {
          if (!(event.which == 48)) {
            event.preventDefault();
          }
        }
        if (List[1] == "2" || List[1] == "7") {
          if (!(event.which == 53)) {
            event.preventDefault();
          }
        }
      }
    }
    if (text.length == 4) {
      let type = text.split(".");
      if (type[1].length == 2) {
        event.preventDefault();
      }
      if (type[1] == "5" || type[1] == "0") {
        if (!(event.which == 48)) {
          event.preventDefault();
        }
      }
      if (type[1] == "2" || type[1] == "7") {
        if (!(event.which == 53)) {
          event.preventDefault();
        }
      }
    }
    let val = text.split('.');
    if (text.length > 4) {
      event.preventDefault();
    }
  }
  errorlist: any = []
  reasonForModify: string;
  //.........................................SaveTimesheets.............................................
  SaveEVVTimesheets() {
    this.IsButtonDisable = true;
    let validateTotalHours = 0;
    this.EvvTimesheetOrderList.forEach(element => {


      if (element.hours == 0 || element.hours == "" || element.hours == null) {
        validateTotalHours = validateTotalHours + 1;
      }
    });
    if (validateTotalHours == this.EvvTimesheetOrderList.length) {
      this.IsButtonDisable = false;
      this.toasterservice.error(
        "Please enter Total Hours",
        "error",
      );
      return
    }
    if (this.validateTotalAmount == 0) {
      if (this.showTotalamount > this.RemainingAmountEditFilter) {
        this.IsButtonDisable = false;
        this.validateTotalAmount = this.validateTotalAmount + 1;
        document.getElementById("openValidationModal").click();
        return;
      }
    }
    let multi = this.EvvTimesheetOrderList
    multi.forEach(ele => {
      ele.multiplesessionBO.forEach(item => {
        let date1 = (item.visitStartTime != null && item.visitStartTime != undefined && item.visitStartTime != '') ? new Date(ele.StartDate + ' ' + item.visitStartTime) : this.global.getDateTimeString(new Date()).toString();
        let date2 = (item.visitEndTime != null && item.visitEndTime != undefined && item.visitEndTime != '') ? new Date(ele.EndDate + ' ' + item.visitEndTime) : this.global.getDateTimeString(new Date()).toString();
        item.visitStartTime = (date1 != null && date1 != undefined && date1 != '') ? this.global.getDateTimeString(date1) : ''
        item.visitEndTime = (date2 != null && date2 != undefined && date2 != '') ? this.global.getDateTimeString(date2) : ''
        item.totalHours = (item.totalHours != null && item.totalHours != undefined && item.totalHours != '') ? parseFloat(item.totalHours) : 0

      })

    })
    let Tj = 0
    let setArrayList: any = []
    for (let TS = 0; TS < this.EvvTimesheetOrderList.length; TS++) {
      let values = this.EvvTimesheetOrderList[TS].hours;
      // let Rate = this.EvvTimesheetOrderList[TS].Rate;
      setArrayList[Tj] = {

        id: "00000000-0000-0000-0000-000000000000",
        totalHours: (this.EvvTimesheetOrderList[TS].hours == "" || this.EvvTimesheetOrderList[TS].hours == 0 ||
          this.EvvTimesheetOrderList[TS].hours == undefined) ? 0 : parseFloat(values),
        // Rate: (Rate == null || Rate == undefined || Rate == '') ? 0 : parseFloat(Rate),
        visitStartTime: this.global.getDateTimeString(this.EvvTimesheetOrderList[TS].StartDate),
        visitEndTime: this.global.getDateTimeString(this.EvvTimesheetOrderList[TS].EndDate),
        totalAmount: (this.EvvTimesheetOrderList[TS].totalAmount == "" || this.EvvTimesheetOrderList[TS].totalAmount == 0 ||
          this.EvvTimesheetOrderList[TS].totalAmount == undefined) ? 0 : this.EvvTimesheetOrderList[TS].totalAmount,
        multiplesessionBO: multi[TS].multiplesessionBO,
        reasonForModify: this.reasonForModify,
        clientId: this.ClientEditFilter,
        employeeId: this.EmployeeEditFilter,
        clientAuthorizationId: this.ServiceEditFilter,
        serviceId: this.ActiveAuthorizationList?.filter(a => a.id == this.ServiceEditFilter)[0].serviceId

      }
      Tj++;


    }



    this.TEditservice.saveEvvTimesheet(setArrayList).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.IsButtonDisable = false;
      if (data.length == 0) {
        this.toasterservice.success('EvvTimesheets saved successfully!');
        this.errorlist = []
        this.backtoEvvTimesheetList();
      }
      else {
        setArrayList.forEach(e => {
          e.multiplesessionBO.forEach(ele => {
            ele.visitStartTime = ''
            ele.visitEndTime = ''
            ele.totalHours = 0
          })
        })

        this.EvvTimesheetOrderList.forEach(e => {
          e.totalAmount = 0;
          e.hours = 0;
        })
        this.errorlist = data
        document.getElementById("errorpopup").click()


      }

    },
    (err: HttpErrorResponse) => {
      this.IsButtonDisable = false;
      this.toasterservice.error(err.error, 'error');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
    });



  }
  //.............................................................backtoTimesheetList..........................................
  backtoEvvTimesheetList() {
    this.EditInputProperty.isCreate = false;
    this.EditInputProperty.clientid = this.ClientEditFilter
    this.EditInputProperty.employeeid = this.EmployeeEditFilter
    this.EditInputProperty.serviceid = this.ServiceEditFilter
    this.EditInputProperty.startdate = this.FromDateFilter
    this.EditInputProperty.enddate = this.EndDateFilter
    this.EditOutputTimesheet.emit(this.EditInputProperty);
  }
  //......................................................cancelValidation........................................
  cancelValidation() {
    this.validateTotalAmount = 0;
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
  ContactColumn: boolean = false;


  removeTime(index) {
    if (this.Multiplesessionlist.length > 1) {
      this.Multiplesessionlist.splice(index, 1);
    }
  }


  saveEvvErr: string = "";

  ///////Hours Calculation/////
  hourscal(starttime, endtime, index, multipleItems) {
    if (starttime != null && endtime != null && starttime != "" && endtime != "") {
      let start = ''
      let end = ''

      let time1: any = starttime.split(' ');
      let time2: any = time1[0].split(':');
      time2[0] = (time1[1] === 'PM' ? (1 * time2[0] + 12) : time2[0]);
      const time12 = (time2[0] < 10 ? '0' + time2[0] : time2[0]) + ':' + time2[1] + ':00';
      start += this.DATE + ' ' + time12.toString()

      let time3: any = endtime.split(' ');
      let time4: any = time3[0].split(':');
      time4[0] = (time3[1] === 'PM' ? (1 * time4[0] + 12) : time4[0]);
      const time34 = (time4[0] < 10 ? '0' + time4[0] : time4[0]) + ':' + time4[1] + ':00';
      end += this.DATE + ' ' + time34.toString()


      if (new Date(start).getTime() <= new Date(end).getTime()) {
        let StartTime = new Date(start).getTime();
        let EndTime = new Date(end).getTime();
        let liststart = new Date(start)
        let listend = new Date(end)
        let diff = EndTime - StartTime;
        var hours = Math.floor(diff / 1000 / 60 / 60);
        diff -= hours * 1000 * 60 * 60;
        var minutes = Math.floor(diff / 1000 / 60);
        if (minutes <= 7) {
          minutes = 0
        }
        else if (minutes <= 22) {
          minutes = 25
        }
        else if (minutes <= 37) {
          minutes = 50
        }
        else if (minutes <= 52) {
          minutes = 75
        }
        else {
          minutes = 0;
          hours += 1;
        }

        this.Multiplesessionlist[index].totalHours = hours + "." + minutes;

        let sum: number = 0
        this.Multiplesessionlist.forEach(element => {
          sum = sum + parseFloat(element.totalHours)
          if (sum > 23.75) {
            this.toasterservice.error('Entered Timings are Over 24 Hours');
            element.visitStartTime = ''
            element.visitEndTime = ''
            element.totalHours = 0
          }

        });


      }
      else {
        this.saveEvvErr = "end time should greater than start time"


        setTimeout(() => {
          this.saveEvvErr = ""
          this.Multiplesessionlist[index].visitStartTime = ''
          this.Multiplesessionlist[index].visitEndTime = ''
          this.Multiplesessionlist[index].totalHours = 0
        }, 2000);
      }
    }

    let currDate = new Date();
    let CurrentHours = currDate.getHours();
    let CurrentMin = currDate.getMinutes();
    let EndtimeHoursMin = endtime?.split(':')
    if ((this.DATE.toString() == currDate.toLocaleDateString())
      && (endtime != null && endtime != undefined && endtime != "")) {
      if ((parseInt(EndtimeHoursMin[0]) == CurrentHours) && (parseInt(EndtimeHoursMin[1]) > CurrentMin)) {
        this.saveEvvErr = "StartTime and EndTime cannot be greater than current date"

        setTimeout(() => {
          this.saveEvvErr = ""
          this.Multiplesessionlist[index].visitStartTime = ''
          this.Multiplesessionlist[index].visitEndTime = ''
          this.Multiplesessionlist[index].totalHours = 0

        }, 2000);

      }
      else if (parseInt(EndtimeHoursMin[0]) > CurrentHours) {
        this.saveEvvErr = "StartTime and EndTime cannot be greater than current date"

        setTimeout(() => {
          this.saveEvvErr = ""
          this.Multiplesessionlist[index].visitStartTime = ''
          this.Multiplesessionlist[index].visitEndTime = ''
          this.Multiplesessionlist[index].totalHours = 0

        }, 2000);

      }

    }


  }


  ///////////////////  Add TimeList /////////////////////////


  Multiplesessionlist: any = []
  indexpush: any;

  DATE: string;

  AddTime(index, assignTimesheetDetails) {

    this.indexpush = index;


    this.DATE = assignTimesheetDetails.StartDate
    if (assignTimesheetDetails.multiplesessionBO.length == 0) {

      this.Multiplesessionlist = [];
      let MultipleSessionEvvTimesheets = new MultipleSessionBO();
      this.Multiplesessionlist.push(MultipleSessionEvvTimesheets)

    }

    let MultipleSesion;

    for (MultipleSesion = 0; MultipleSesion < this.EvvTimesheetOrderList.length; MultipleSesion++) {

      if (this.EvvTimesheetOrderList[MultipleSesion].multiplesessionBO.length > 0) {

        if (this.indexpush == MultipleSesion) {

          let timelist = this.EvvTimesheetOrderList[MultipleSesion].multiplesessionBO;

          this.Multiplesessionlist = timelist

        }

      }

    }


  }




  AddTimeList() {
    let MultipleSessionEvvTimesheets = new MultipleSessionBO();
    this.Multiplesessionlist.push(MultipleSessionEvvTimesheets)
    this.ContactColumn = true
  }

  closeTimeList() {

    let sum: number = 0
    this.Multiplesessionlist.forEach(element => {
      sum = sum + parseFloat(element.totalHours)
    });

    this.EvvTimesheetOrderList[this.indexpush].hours = (sum != null && sum != undefined) ? parseFloat(sum.toString()).toFixed(2) : 0
    this.EvvTimesheetOrderList[this.indexpush].totalAmount = this.EvvTimesheetOrderList[this.indexpush].hours * this.EvvTimesheetOrderList[this.indexpush].Rate
    this.EvvTimesheetOrderList.forEach((element, index) => {

      if (index == this.indexpush) {
        element.multiplesessionBO = this.Multiplesessionlist

      }
    });

    if (this.EvvTimesheetOrderList[this.indexpush].hours != null && this.EvvTimesheetOrderList[this.indexpush].hours != undefined && this.EvvTimesheetOrderList[this.indexpush].hours != '') {
      this.calculatehours(this.EvvTimesheetOrderList)
    }

  }




  cleartimelist(multipleItems, index) {
    this.Multiplesessionlist.forEach((element, ind) => {
      if (ind == index) {
        element.visitStartTime = ''
        element.visitEndTime = ''
        element.totalHours = 0
      }

    });
  }



  ngAfterContentChecked() {

    this.cdr.detectChanges();

  }


}

